export default __webpack_public_path__ + "static/media/Astro_Virgo_White.11d6d54c.png";